import { pagePath } from '@/utils/router/pagePath';
/**
 * パンくず内容
 */
export const hotlineProFirstReplyBreadcrumbs = (type, id, title) => [
    { link: pagePath.mypage.professional.index(), text: 'マイページ' },
    {
        link: pagePath.hotline.professional.list(),
        text: '匿名ホットライン相談一覧',
    },
    { link: pagePath.hotline.professional.detailNegotiate(id), text: title },
    {
        text: {
            complete: '初回返信完了',
            confirm: '初回返信内容を確認',
            input: '初回返信内容を入力',
        }[type],
    },
];
